import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images/optimized-image';
import { TickerDisplay } from '@/components/ui/ticker-display';
interface WinnerPageHeaderProps {
  marketPubkey: string;
  marketTitle: string;
  marketTicker: string | null;
  marketCategory: string;
  coverImageUrl: string | null;
  coverImageNsfw: boolean;
}

/**
 * Winner-detail-page recap header — the parent-market context variant of the
 * resolved panel. An eyebrow "RESOLVED FROM MARKET" over the market thumbnail +
 * title + ticker. Distinct from `WinnerHeader` (which fronts the winning token
 * on the market page); here the surface already IS the winning token, so we
 * surface the market it came from instead. The "View market" CTA lives at the
 * bottom of the recap (see `ResolvedPanel`).
 */
export function WinnerPageHeader(t0) {
  const $ = _c(24);
  const {
    marketPubkey,
    marketTitle,
    marketTicker,
    marketCategory,
    coverImageUrl,
    coverImageNsfw
  } = t0;
  const t = useTranslations("market.resolvedPanel");
  let t1;
  if ($[0] !== t) {
    t1 = t("resolvedFromMarket");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-caption font-medium uppercase tracking-wide text-foreground-tertiary">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== coverImageNsfw || $[5] !== coverImageUrl || $[6] !== marketCategory || $[7] !== marketPubkey) {
    t3 = {
      kind: "market",
      pubkey: marketPubkey,
      category: marketCategory,
      coverImageUrl,
      nsfw: coverImageNsfw
    };
    $[4] = coverImageNsfw;
    $[5] = coverImageUrl;
    $[6] = marketCategory;
    $[7] = marketPubkey;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== marketTitle || $[10] !== t) {
    t4 = t("marketCoverAlt", {
      title: marketTitle
    });
    $[9] = marketTitle;
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = <OptimizedImage variant="thumbnail" entity={t3} alt={t4} size="size-10" rounded="rounded-panel-inset" preview={false} loadReveal="none" className="size-10 shrink-0 object-cover" />;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== marketTicker || $[16] !== marketTitle) {
    t6 = <TickerDisplay label={marketTitle} ticker={marketTicker} wrap={true} labelClassName="text-heading font-medium text-foreground-secondary" />;
    $[15] = marketTicker;
    $[16] = marketTitle;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className="flex min-w-0 items-center gap-3">{t5}{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t7) {
    t8 = <div className="flex flex-col gap-2">{t2}{t7}</div>;
    $[21] = t2;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
}